import classNames from 'classnames';
import React from 'react';
interface CreatedDateProps {
  createdDate: string;
  status: 'published' | 'rejected' | 'pending';
}
const CreateDate = ({createdDate, status}: CreatedDateProps) => {
  return (
    <span
      className={classNames(
        'w-[30%]  top-2 right-1 text-xs flex justify-center text-error-1  py-1 px-2 rounded-3xl',
        {'bg-white text-secondary': status === 'published'},
        {'bg-red-1 text-error': status === 'rejected'},
        {'bg-orange-4 text-warning-2 ': status === 'pending'},
      )}
    >
      {status === 'published' && createdDate}
      {status === 'rejected' && 'تایید نشده'}
      {status === 'pending' && 'در انتظار تایید'}
    </span>
  );
};

export default CreateDate;
